import { ComponentType } from 'react';
import { BillableHoursByMonthReport } from './executive/BillableHoursByMonthReport';
import { BillableHoursByYearReport } from './executive/BillableHoursByYearReport';
import { TopCasesByBillableHoursReport } from './executive/TopCasesByBillableHoursReport';
import { TopCasesByInvoicedHoursReport } from './executive/TopCasesByInvoicedHoursReport';
import { TopClientsByRevenueReport } from './executive/TopClientsByRevenueReport';
import { TopPayersByRevenueReport } from './executive/TopPayersByRevenueReport';
import { DraftInvoicesByCaseReport } from './finance/DraftInvoicesByCaseReport';
import { InvoiceTotalsByAccountingTypeReport } from './finance/InvoiceTotalsByAccountingTypeReport';
import { InvoiceTotalsByPayerCountryReport } from './finance/InvoiceTotalsByPayerCountryReport';
import { InvoicedHourlyRatesReport } from './finance/InvoicedHourlyRatesReport';
import { InvoicedWorkByEmployeeAndMonthReport } from './finance/InvoicedWorkByEmployeeAndMonthReport';
import { InvoicedWorkByEmployeeAndYearReport } from './finance/InvoicedWorkByEmployeeAndYearReport';
import { RevenueByEmployeeReport } from './finance/RevenueByEmployeeReport';
import { InvoicedFeesByCaseAndAssignmentReport } from './operations/InvoicedFeesByCaseAndAssignmentReport';
import { WipByCaseAndTimecardStatusReport } from './operations/WipByCaseAndTimecardStatusReport';
import { WipByCaseReport } from './operations/WipByCaseReport';
import { BillableHoursByEmployeeAndMonthReport } from './performance/BillableHoursByEmployeeAndMonthReport';
import { BillableHoursByEmployeeAndYearReport } from './performance/BillableHoursByEmployeeAndYearReport';
import { ProductivityByEmployeeAndCaseReport } from './performance/ProductivityByEmployeeAndCaseReport';
import { ProductivityByEmployeeReport } from './performance/ProductivityByEmployeeReport';
import { WorkingTimeByEmployeeReport } from './performance/WorkingTimeByEmployeeReport';
import { ReportEntry } from './reportCatalog';

/** The page of each report in the catalogue. */
export const REPORT_PAGES: Record<string, ComponentType<{ report: ReportEntry }>> = {
    'top-cases-by-invoiced-hours': TopCasesByInvoicedHoursReport,
    'top-cases-by-billable-hours': TopCasesByBillableHoursReport,
    'top-clients-by-revenue': TopClientsByRevenueReport,
    'top-payers-by-revenue': TopPayersByRevenueReport,
    'revenue-by-employee': RevenueByEmployeeReport,
    'invoiced-hourly-rates-by-employee-and-case': InvoicedHourlyRatesReport,
    'invoice-totals-by-accounting-type': InvoiceTotalsByAccountingTypeReport,
    'invoice-totals-by-payer-country': InvoiceTotalsByPayerCountryReport,
    'draft-invoices-by-case': DraftInvoicesByCaseReport,
    'wip-by-case': WipByCaseReport,
    'wip-by-case-and-timecard-status': WipByCaseAndTimecardStatusReport,
    'invoiced-fees-by-case-and-assignment': InvoicedFeesByCaseAndAssignmentReport,
    'productivity-by-employee': ProductivityByEmployeeReport,
    'productivity-by-employee-and-case': ProductivityByEmployeeAndCaseReport,
    'working-time-by-employee': WorkingTimeByEmployeeReport,
    'billable-hours-by-month': BillableHoursByMonthReport,
    'billable-hours-by-year': BillableHoursByYearReport,
    'invoiced-work-by-employee-and-month': InvoicedWorkByEmployeeAndMonthReport,
    'invoiced-work-by-employee-and-year': InvoicedWorkByEmployeeAndYearReport,
    'billable-hours-by-employee-and-month': BillableHoursByEmployeeAndMonthReport,
    'billable-hours-by-employee-and-year': BillableHoursByEmployeeAndYearReport,
};
